import React, { useState, useEffect } from 'react';

const DisclaimerEditor = () => {
  const [disclaimer, setDisclaimer] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    // Fetch the current disclaimer text
    fetch('https://back.startupconnectz.com/api/admin/disclaimer')
      .then((response) => response.json())
      .then((data) => {
        setDisclaimer(data.text);
        setLoading(false);
      })
      .catch(() => {
        setError('Error fetching disclaimer');
        setLoading(false);
      });
  }, []);

  const handleSubmit = () => {
    setSuccess(false);
    fetch('https://back.startupconnectz.com/api/admin/update-disclaimer', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ text: disclaimer }),
    })
      .then((response) => response.json())
      .then(() => {
        setSuccess(true);
      })
      .catch(() => {
        setError('Error updating disclaimer');
      });
  };

  if (loading) return <div className="loading-message">Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="disclaimer-editor-container">
      <h2>Edit Disclaimer</h2>
      <textarea
        value={disclaimer}
        onChange={(e) => setDisclaimer(e.target.value)}
        rows={10}
        cols={50}
        className="disclaimer-textarea"
      />
      <br />
      <button onClick={handleSubmit} className="update-btn">Update Disclaimer</button>
      {success && <div className="success-message">Disclaimer updated successfully!</div>}
    </div>
  );
};

export default DisclaimerEditor;
